"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldReferenceRest = function () {
  function FieldReferenceRest($http) {
    (0, _classCallCheck3.default)(this, FieldReferenceRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      FIELD_REFERENCES_AVAILABLE_CHOICES: 'field-references/available-choices/'
    };
  }

  (0, _createClass3.default)(FieldReferenceRest, [{
    key: "getAvailableChoices",
    value: function getAvailableChoices() {
      return this.$http.get(this.sprintf(this.PATH.FIELD_REFERENCES_AVAILABLE_CHOICES));
    }
  }]);
  return FieldReferenceRest;
}();

exports.default = FieldReferenceRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/FieldReferenceResource.js
// module id = 313
// module chunks = 0